<template>

</template>

<script>
import cartActions from "../../../store/web/cart/action-types";
import cartMutations from "../../../store/web/cart/mutation-types";

export default {
  props: {
    cart: String,
    updateCartUrl: String,
  },
  created () {
    this.$store.dispatch('cart/' + cartActions.UPDATE_CART, JSON.parse(this.cart));
    this.$store.commit('cart/' + cartMutations.SET_UPDATE_CART_URL, this.updateCartUrl);
  },
}
</script>
